module.exports = __webpack_public_path__ + "img/product_1.b75c223b.jpg";